import React from 'react'

import { BoxClosedOrderTabIcon } from '../iconComponents/BoxClosedOrderTabIcon'
import { BoxOpenOrderTabIcon } from '../iconComponents/BoxOpenOrderTabIcon'
import { CancelledOrderTabIcon } from '../iconComponents/CancelledOrderTabIcon'
import { KnifeAndForkOrderTabIcon } from '../iconComponents/KnifeAndForkOrderTabIcon'
import { TruckOrderTabIcon } from '../iconComponents/TruckOrderTabIcon'
import type { OrderTab } from './OrderTabs.types'

type OrderTabIconProps = {
  icon: OrderTab['icon']
}

export function OrderTabIcon({ icon }: OrderTabIconProps) {
  if (icon === 'boxClosed') {
    return <BoxClosedOrderTabIcon testId="order-tab-custom-icon-box-close" />
  }

  if (icon === 'boxOpen') {
    return <BoxOpenOrderTabIcon testId="order-tab-custom-icon-box-open" />
  }

  if (icon === 'cancelled') {
    return <CancelledOrderTabIcon testId="order-tab-custom-icon-cancelled" />
  }

  if (icon === 'knifeAndFork') {
    return <KnifeAndForkOrderTabIcon testId="order-tab-custom-icon-knife-and-fork" />
  }

  if (icon === 'truck') {
    return <TruckOrderTabIcon testId="order-tab-custom-icon-truck" />
  }

  return <BoxOpenOrderTabIcon testId="order-tab-custom-icon-box-open" />
}
